module.exports = __webpack_public_path__ + "media/graphic2/proxy-illustratie-d9aa513f.svg";